export const CHECKOUT_APP_CONFIG_QUERY = `
query ConfigurationQuery {
  aggregatedCheckoutAppConfiguration {
    checkoutConfiguration {
      data {
        countryIdentifier
        languageIdentifier
        orderLimit
        features
        companyName
        primaryCurrency {
          decimalPlaces
          currencySymbol
          currencyFormat
          currency
        }
        secondaryCurrency {
          decimalPlaces
          currencySymbol
          currencyFormat
          conversionRate
          currency
        }
      }
      messages
    }
    headerConfiguration {
      data {
        quickContact {
          phoneNumbers
          isCallCenterOpen
          workingHours
        }
      }
      messages
    }
  }
}
`;
